package app.components

import dev.fritz2.core.RenderContext
import dev.fritz2.core.disabled

fun RenderContext.buttonText(
    text: String,
    onClick: () -> Unit,
    isDisabled: Boolean = false,
    className: String = "px-4 py-2 bg-blue-500 text-white rounded disabled:cursor-not-allowed disabled:opacity-50"
) {
    button(className) {
        +text
        disabled(isDisabled)
        clicks handledBy { onClick() }
    }
}
